import { fetchServer } from "@/features/utils/fetch.ts";
import { ResponseListDocumentsConsent, ResponseSubmitDocumentConsent } from "../types";
import { DocumentAction } from "@/molecules/consent-document/ConsentDocument.react";

export class ConsentApiClient {
  static async listDocumentsConsent(): Promise<ResponseListDocumentsConsent> {
    const response = await fetchServer(`/documentConsent/list`, {
      method: "GET",
      reloadOn401: false,
      mainRoot: false
    });
    const res = await response.json();
    return res;
  }

  static async submitDocumentConsent(body: {
    action: DocumentAction;
    documentConsentUuid: string;
    comment?: string;
  }): Promise<ResponseSubmitDocumentConsent> {
    const response = await fetchServer(`/documentConsent/consent`, {
      method: "POST",
      reloadOn401: false,
      mainRoot: false,
      body
    });
    const data = (await response.json()) as ResponseSubmitDocumentConsent;
    return data;
  }
}
